import React from 'react'
import PropTypes from 'prop-types'
import {PopoverContext} from './PopoverContext'
import {usePopover} from './usePopover'

const Popover = ({
    children,
    isOpen,
    defaultOpen = false,
    onOpenChange,
    placement = 'bottom',
    offset = 7,
    showArrow = false,
    trigger = 'click',
    shouldCloseOnBlur = true,
    shouldCloseOnScroll = false,
    shouldFlip = true,
    backdrop = 'transparent',
    size = 'md',
    radius = 'lg',
    shadow = 'md',
}) => {
    const popover = usePopover({
        isOpen,
        defaultOpen,
        onOpenChange,
        placement,
        offset,
        showArrow,
        trigger,
        shouldCloseOnBlur,
        shouldCloseOnScroll,
        shouldFlip,
    })

    const contextValue = {
        ...popover,
        showArrow,
        backdrop,
        size,
        radius,
        shadow,
    }

    return (
        <PopoverContext.Provider value={contextValue}>
            {children}
        </PopoverContext.Provider>
    )
}

Popover.propTypes = {
    children: PropTypes.node.isRequired,
    isOpen: PropTypes.bool,
    defaultOpen: PropTypes.bool,
    onOpenChange: PropTypes.func,
    placement: PropTypes.oneOf([
        'top', 'top-start', 'top-end',
        'bottom', 'bottom-start', 'bottom-end',
        'left', 'left-start', 'left-end',
        'right', 'right-start', 'right-end',
    ]),
    offset: PropTypes.number,
    showArrow: PropTypes.bool,
    trigger: PropTypes.oneOfType([
        PropTypes.oneOf(['click', 'hover', 'focus']),
        PropTypes.arrayOf(PropTypes.oneOf(['click', 'hover', 'focus'])),
    ]),
    shouldCloseOnBlur: PropTypes.bool,
    shouldCloseOnScroll: PropTypes.bool,
    shouldFlip: PropTypes.bool,
    backdrop: PropTypes.oneOf(['transparent', 'opaque', 'blur']),
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    radius: PropTypes.oneOf(['sm', 'md', 'lg']),
    shadow: PropTypes.oneOf(['sm', 'md', 'lg']),
}

export default Popover
